module.exports = __webpack_public_path__ + "static/media/icons-confirmation-email.21d0e40c.svg";